// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pPfW9qr3LABxih3s5Gi9{height:100%;width:100%}`, "",{"version":3,"sources":["webpack://./src/components/MonacoSection/monaco-section.module.scss"],"names":[],"mappings":"AAAA,sBACI,WAAA,CACA,UAAA","sourcesContent":[".monacoSection {\n    height: 100%;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monacoSection": `pPfW9qr3LABxih3s5Gi9`
};
export default ___CSS_LOADER_EXPORT___;
